import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardIcon from '@mui/icons-material/Dashboard';
import LogoutIcon from '@mui/icons-material/Logout';
import PhotoCameraBackIcon from '@mui/icons-material/PhotoCameraBack';
import AuthContext, { AuthProvider } from '../context/AuthContext';
// Dummy user for demonstration (replace with actual auth logic or props/context)
// const user = { user_id: 1 }; // Replace with actual user ID

const Navbar = () => {
  const navigate = useNavigate();

  const handleDashboardClick = () => {
    navigate('/');
  };

  const handleLogoutClick = () => {
    navigate('/login');
  };

  return (
    <div style={navbarStyles.navbar}>
      <div style={navbarStyles.title}>Volunteer Dashboard</div>
      <div style={navbarStyles.actions}>
        <div style={navbarStyles.iconGroup} onClick={handleDashboardClick}>
          <DashboardIcon style={navbarStyles.icon} />
          <span style={navbarStyles.label}>DASHBOARD</span>
        </div>
        <div style={navbarStyles.iconGroup} onClick={handleLogoutClick}>
          <LogoutIcon style={navbarStyles.icon} />
        </div>
      </div>
    </div>
  );
};

const ScoutingMediaList = () => {
  const {user} = useContext(AuthContext);
  const navigate = useNavigate();
  const [scoutingWeeks, setScoutingWeeks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchReports = async () => {
    // console.log(user.username)
    try {
      // const api_link = `http://localhost:8000/fetch-scouting-reports/${user.username}`
      const api_link = `https://api.mba-gris.stgafrica.org/fetch-scouting-reports/${user.username}`
      const res = await fetch(api_link);
      if (!res.ok) throw new Error('Failed to fetch reports');
      const data = await res.json();
      setScoutingWeeks(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReports();
  }, []);

  const handleSubmitImage = (report_id) => {
    navigate(`/upload-scouting-media/${report_id}`);
  };

  return (
    <>
      <Navbar />
      <div style={styles.container}>
        <div style={{ textAlign: 'center' }}>
          <img src={require("../assets/images/mba-logo.png")} alt="Logo" style={{ width: '100px', height: 'auto' }} />
        </div>
        <h2 style={styles.heading}>Scouting Media Submission</h2>
        <p style={styles.subHeading}>Select a week to submit your images and videos.</p>

        {loading ? (
          <p>Loading reports...</p>
        ) : error ? (
          <p style={{ color: 'red' }}>{error}</p>
        ) : (
          <ul style={styles.weekList}>
            {scoutingWeeks.map((week) => (
              <li key={week.report_id} style={styles.weekItem} onClick={() => handleSubmitImage(week.report_id)}>
                <PhotoCameraBackIcon style={styles.icon} />
                <span>{week.reporting_week}</span> - <span>{week.report_date}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </>
  );
};

// Styles remain the same as before...
const navbarStyles = {
  navbar: {
    backgroundColor: '#2e7d32',
    color: '#fff',
    padding: '15px 30px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    fontSize: '18px',
    fontWeight: 'bold',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: '25px',
  },
  iconGroup: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    gap: '6px',
  },
  icon: {
    fontSize: '24px',
  },
  label: {
    fontSize: '14px',
    fontWeight: '500',
  },
};

const styles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    maxWidth: '800px',
    margin: '40px auto',
    padding: '20px',
    border: '1px solid #ddd',
    borderRadius: '10px',
    backgroundColor: '#fff',
    boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
    textAlign: 'center',
  },
  heading: {
    color: '#333',
    marginBottom: '10px',
  },
  subHeading: {
    color: '#555',
    marginBottom: '30px',
  },
  weekList: {
    listStyle: 'none',
    padding: 0,
  },
  weekItem: {
    backgroundColor: '#f1f1f1',
    padding: '15px 20px',
    margin: '10px 0',
    borderRadius: '8px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    transition: 'background-color 0.2s ease',
  },
  icon: {
    color: '#2e7d32',
  },
};

export default ScoutingMediaList;
